import { url } from 'utils/urls';
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export const fetchContentsData = (embedUUID, cookieId, contentOrder, numberOfQuestionsLimit) => {
    const requestUrl = `${url.api.contents}?embed_uuid=${embedUUID}&cookie_id=${cookieId}&content_order=${contentOrder}&for_embed=true` +
        `${numberOfQuestionsLimit === null ? '' : `&content_count=${numberOfQuestionsLimit}`}`;
    return new Promise(function (resolve, reject) {
        let xhr = new XMLHttpRequest();
        xhr.open('GET', requestUrl, true);
        xhr.responseType = 'text';
        xhr.onload = function () {
            if (this.status >= 200 && this.status < 300) {
                resolve(JSON.parse(xhr.response));
            } else {
                reject({
                    status: this.status,
                    statusText: xhr.statusText
                });
            }
        };
        xhr.onerror = function () {
            reject({
                status: this.status,
                statusText: xhr.statusText
            });
        };
        xhr.send(null);
    });
};


export const fetchQuestionnaireData = (cookieId, callParams) => {
    // const requestUrl =`${url.api.getQuestionnaire}?for_embed=true&cookie_id=${cookieId}` +
    //     `&survey_type=${uniqueueProps.questionnaireType}&qc=${uniqueueProps.numberOfQuestions}` +
    //     `${uniqueueProps.questionnaireType === 'LIFESTYLE' ? `&sc=${uniqueueProps.numberOfQuestionnaires}` : ''}`;
    const requestUrl = `${url.api.getQuestionnaire}?` +
        `for_embed=true` +
        `&cookie_id=${cookieId}` +
        `&survey_type=${callParams.surveyType}` +
        `&qc=${callParams.qc}` +
        `${callParams.page_url !== null ? `&page_url=${callParams.page_url}` : ``}` +
        `${callParams.sc !== null ? `&sc=${callParams.sc}` : ``}` +
        `${callParams.mqc !== null ? `&mqc=${callParams.mqc}` : ``}` +
        `${callParams.exclude !== null ? _formExcludedCategories(callParams.exclude) : ``}`;
        // log('QUESTIONNAIRE CALL', 'requestUrl', requestUrl);
    return new Promise(function (resolve, reject) {
        let xhr = new XMLHttpRequest();
        xhr.open('GET', requestUrl, true);
        xhr.responseType = 'text';
        xhr.onload = function () {
            if (this.status >= 200 && this.status < 300) {
                // log('QUESTIONNAIRE CALL', xhr.response);
                resolve(JSON.parse(xhr.response));
            } else {
                reject({
                    status: this.status,
                    statusText: xhr.statusText
                });
            }
        };
        xhr.onerror = function () {
            reject({
                status: this.status,
                statusText: xhr.statusText
            });
        };
        xhr.send(null);
    });
};


const _formExcludedCategories = categories => {
    let queryString = [];
    for (let category of categories) {
        queryString.push(`&exclude=${category}`);
    }
    return queryString.join('');
};